import { ResetPasswordView } from "../components/auth/reset-password/ResetPasswordView";
import { BackgroundLayout } from "../layouts/BackgroundLayout";

const ResetPasswordPage = () => {
  return (
    <BackgroundLayout>
      <ResetPasswordView />
    </BackgroundLayout>
  );
};

export { ResetPasswordPage };
